<div class=" container-fluid py-3 left-menu-space" id="divMainContainer" role="main" *ngIf="!isView">
  <div class="page-title-box d-flex row bd-highlight">
    <h4 class="mb-0 f-bold-dubai text-secondary pb-1  col-sm-5">User Master</h4>
    <div class="page-title-right pb-1 col-sm-7">
      
      <div class="float-sm-right order-sm-2">
       
        <a *ngIf="tempuseraccess" title="Reset Meeting Action" class="btn" style="cursor:pointer;" (click)="redirectResetMeetingAction()"><i class="fa fa-users"></i></a>
        <a title="Refresh User Cache" class="btn" style="cursor:pointer;" (click)="updateCacheUser()"><i class="fa fa-refresh"></i></a>
        <a class="btn" style="cursor:pointer;" (click)="exportExcel()"><i class="fa fa-file-excel-o fa-lg"></i></a>
        <a class="btn btn-success btn-sm text-white rounded-circle text-center px-0 wh-30" (click)="openModal(userMasterAdd,'add')"><i class="la la-plus fa-lg "></i></a>
      </div>
      <div class="form-group position-relative float-sm-right order-sm-1 col-md-6 pr-5">
        <input type="text" class="form-control pr-4" id="formGroupExampleInput2" placeholder="Search" [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}">
        <button (click)="loadUserMaster(true)" class="position-absolute position-top-0  position-right-5 d-block pt-2 pb-1 border-top-left-right-0 btn btn-light border"><i class="la la-search fa-lg text-secondary rotate-icon" title="Search"></i><span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1 position-relative position-top-minus-5"></span></button>
      </div>

    </div>
  </div>

   
  <div class="card rounded pt-2 h-100 pageloadcontainer">
    <div class="loader-bg" *ngIf="isLoader"></div>
    <div *ngIf="user_data==null ||user_data.length<=0 && !isLoader" class="border px-3 py-4 text-center rounded text-secondary">
      <!--<img src="{{noDataImage}}" alt="No Data" />-->
      <h5 class="pb-4 pt-2">No Data Available</h5>
    </div>
    <div class="pt-2 px-3 pb-3 border-bottom position-relative" *ngFor="let item of user_data">
      <img [src]="item.picture" alt="profile" class="wh-30 rounded-circle mr-2" />
      <h6 class="card-title d-inline f-bold-dubai">{{item.displayNameEn}}</h6>
      <div class="card-controls position-absolute position-top-10 position-right-10">
        <ul class="list-inline list-badge hide-arrow-drop">
          <li class="list-inline-item nav-item" ngbDropdown>
            <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle><i class="la la-ellipsis-v fa-lg"></i></a>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <li (click)="openModal(userMasterAdd,'edit');editUserMaster(item);isView=false;"><a ngbDropdownItem><i class="fa fa-edit"></i> Edit</a></li>
              <li (click)="isView=true;userInfo(item);"><a ngbDropdownItem><i class="fa fa-eye"></i> View</a></li>
              <li (click)="DeleteConfirm(item)"><a ngbDropdownItem><i class="la la-trash-o"></i> Delete</a></li>
              <li *ngIf="tempuseraccess" (click)="switchUserConfirm(item.ntUsername)"><a ngbDropdownItem><i class="fa fa-sign-in fa-lg"></i> Switch user</a></li>
              <li *ngIf="item.externalUser == 1 && item.isBlocked ==1"><a ngbDropdownItem (click)="ResetConfirm(item)"><i class="fa fa-exchange"></i> Reset</a></li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="text-success py-1">{{item.designationEn}}</div>
      <div class="p-0">
        <span class="pr-2"> {{item.prNumber}}</span> |  <span class="px-2">{{item.emailId}}</span> | <span class="px-2"><b class="text-secondary">{{item.divisionNameEn}}</b></span>| <span class="px-2">{{item.ntUsername}}</span>
      </div>
    </div>


  </div>
  
</div>
<ng-template #userMasterAdd>
  <div class="modal-header pb-0">
    <div class="custom-tab d-block w-100">
      <h4 class="modal-title text-left px-2">Add New User</h4>
      <small class="px-2"><a (click)="modalRef.hide()" class="text-secondary"></a></small>
      <button type="button" class="close close-abs text-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true"><i class="la la-close"></i></span>
      </button>
    </div>
  </div>
  <form name="userMasterForm" (ngSubmit)="userMasterForm.form.valid && AddEditUserMaster()" [mustMatch]="['password', 'confirmPassword']" #userMasterForm="ngForm" novalidate>
    <div class="modal-body px-3" style="height: 75vh !important">
      <div class="row">
        <div *ngIf="isEdit" class="col-md-6 col-sm-6">
          <div class="form-group">
            <span>{{ntUser}}</span>
          </div>
        </div>
        <div class="form-group" *ngIf="!isEdit">
          <div class="col-md-12">
            <label for="displayNameEn">Search By:  &nbsp; &nbsp;</label>
            <!--<input type="radio" name="search" id="ntLogin" value="nt" checked /> NT Login
  <input type="radio" name="search" id="prNumber" value="pr" /> PR Number-->


            <input id="ntlogin"
                   type="radio"
                   value="nt"
                   name="ntlogin"
                   checked
                   (change)="changeSearch('nt')"> NT Login  &nbsp; &nbsp;


            <input id="prNumber"
                   type="radio"
                   value="pr"
                   name="ntlogin"
                   (change)="changeSearch('pr')"> PR Number &nbsp; &nbsp;

            <input id="exUser"
                   type="radio"
                   value="ex"
                   name="ntlogin"
                   (change)="changeSearch('ex')"> External User

          </div>
        </div>
        <div class="col-md-12" *ngIf="!isEdit">


          <!--NT Login-->
          <ng-container *ngIf="(!isEdit&& !isNTLogin && !exUser)">
            <div class="form-group">
              <label for="ntLoginName">NT Login User Name<span class="text-danger">*</span></label>
              <select class="form-control" (change)="onchangeNTUser($event.target.value)" [ngClass]="{ 'is-invalid': userMasterForm.submitted && ntLoginName.invalid } " placeholder="Select NT Login Name" #ntLoginName="ngModel" name="ntLoginName" [(ngModel)]="model.ntLoginName" required>
                <option *ngFor="let item of ntUserDataList; index as i;" [value]="item.ntUsername">{{item.ntUsername}} </option>
              </select>
              <div *ngIf="userMasterForm.submitted && ntLoginName.invalid" class="invalid-feedback">
                <div *ngIf="ntLoginName.errors.required" class="text-danger">Select the NT Login Name</div>
              </div>
              <!--<label class="e-float-text e-label-top" for="ntUsername">NT Login User Name <span class="mant-red">*</span></label>-->
            </div>

          </ng-container>

          <!--PR Number-->
          <ng-container *ngIf="(!isEdit&& isNTLogin  && !exUser)">
            <div class="form-group">
              <label for="prnNumber">PR Number<span class="text-danger">*</span></label>
              <select class="form-control" name="prnNumber" (change)="onchangeNTUser($event.target.value)" [ngClass]="{ 'is-invalid': userMasterForm.submitted && prnNumber.invalid } " placeholder="Select User" #prnNumber="ngModel" [(ngModel)]="model.prnNumber" required>
                <option *ngFor="let item of ntUserDataList; index as i;" [value]="item.prNumber">{{item.prNumber}} </option>
              </select>

              <div *ngIf="userMasterForm.submitted && prnNumber.invalid" class="invalid-feedback">
                <div *ngIf="prnNumber.errors.required" class="text-danger">Select the PR Number</div>
              </div>
            </div>

          </ng-container>


        </div>
        <!--<div class="col-md-6" style="display:none;">
    <div class="form-group">
      <label for="prNumber">PR Number</label>
      <input type="text" class="form-control" [ngClass]="{ 'is-invalid': userMasterForm.submitted && prNumber.invalid }" name="prNumber"
             [(ngModel)]="model.prNumber" #prNumber="ngModel" required placeholder="Enter the meeting room code" />
      <div *ngIf="userMasterForm.submitted && prNumber.invalid" class="invalid-feedback">
        <div *ngIf="prNumber.errors.required" class="text-danger">Enter the pr number</div>
      </div>
    </div>
  </div>-->
        <div class="col-md-6 col-sm-6">
          <div class="form-group">
            <label for="displayNameEn">Display Name English<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="displayNameEn" [ngClass]="{ 'is-invalid': userMasterForm.submitted && displayNameEn.invalid } " name="displayNameEn"
                   [(ngModel)]="model.displayNameEn" #displayNameEn="ngModel" required placeholder="Enter the display name english">
            <div *ngIf="userMasterForm.submitted && displayNameEn.invalid" class="invalid-feedback">
              <div *ngIf="displayNameEn.errors.required" class="text-danger">Enter the display name english</div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="form-group">
            <label for="displayNameAr">Display Name Arabic<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="displayNameAr" [ngClass]="{ 'is-invalid': userMasterForm.submitted && displayNameAr.invalid } " name="displayNameAr"
                   [(ngModel)]="model.displayNameAr" #displayNameAr="ngModel" required placeholder="Enter the display name arabic" />
            <div *ngIf="userMasterForm.submitted && displayNameAr.invalid" class="invalid-feedback">
              <div *ngIf="displayNameAr.errors.required" class="text-danger">Enter the display name arabic</div>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-6 col-sm-6">
          <div class="form-group">
            <label for="emailId">Email ID<span class="text-danger">*</span></label>
            <input type="email" class="form-control" id="emailId" [ngClass]="{ 'is-invalid': userMasterForm.submitted && emailId.invalid } " name="emailId" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                   [(ngModel)]="model.emailId" #emailId="ngModel" required placeholder="Enter the email id">
            <div *ngIf="userMasterForm.submitted && emailId.invalid" class="invalid-feedback">
              <div *ngIf="emailId.errors.required" class="text-danger">Enter the email id</div>
              <div class="text-danger" *ngIf="emailAddr.errors?.pattern">This is not a valid Email!!!</div>
            </div>
          </div>
        </div> -->
        <div class="col-md-6 col-sm-6">
          <div class="form-group">
            <label for="emailId">Email ID<span class="text-danger">*</span></label>
            <input type="email" 
                class="form-control" 
                id="emailId" 
                [ngClass]="{ 'is-invalid': userMasterForm.submitted && emailId.invalid }" 
                name="emailId" 
                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                [(ngModel)]="model.emailId" 
                #emailId="ngModel" 
                required 
                placeholder="Enter the email id">

            <div *ngIf="userMasterForm.submitted && emailId.invalid" class="invalid-feedback">
              <div *ngIf="emailId.errors?.required" class="text-danger">Enter the email id</div>
              <div *ngIf="emailId.errors?.pattern" class="text-danger">Please enter a valid email address (e.g. name@domain.com)</div>
            </div>
          </div>
        </div> 
        <div class="col-md-6 col-sm-6">
          <div class="form-group">
            <label for="firstname">First Name<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="firstname" [ngClass]="{ 'is-invalid': userMasterForm.submitted && firstname.invalid } " name="firstname"
                   [(ngModel)]="model.firstname" #firstname="ngModel" required placeholder="Enter the first name">
            <div *ngIf="userMasterForm.submitted && firstname.invalid" class="invalid-feedback">
              <div *ngIf="firstname.errors.required" class="text-danger">Enter the first name</div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="form-group">
            <label for="lastname">Last Name<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="lastname" [ngClass]="{ 'is-invalid': userMasterForm.submitted && lastname.invalid } " name="lastname"
                   [(ngModel)]="model.lastname" #lastname="ngModel" required placeholder="Enter the last name">
            <div *ngIf="userMasterForm.submitted && lastname.invalid" class="invalid-feedback">
              <div *ngIf="lastname.errors.required" class="text-danger">Enter the last name</div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="form-group">
            <label for="designationEn">Designation Name English<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="designationEn" [ngClass]="{ 'is-invalid': userMasterForm.submitted && designationEn.invalid } " name="designationEn"
                   [(ngModel)]="model.designationEn" #designationEn="ngModel" required placeholder="Enter the designation english">
            <div *ngIf="userMasterForm.submitted && designationEn.invalid" class="invalid-feedback">
              <div *ngIf="designationEn.errors.required" class="text-danger">Enter the designation english</div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="form-group">
            <label for="designationAr">Designation Name Arabic<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="designationAr" [ngClass]="{ 'is-invalid': userMasterForm.submitted && designationAr.invalid } " name="designationAr"
                   [(ngModel)]="model.designationAr" #designationAr="ngModel" required placeholder="Enter the designation arabic">
            <div *ngIf="userMasterForm.submitted && designationAr.invalid" class="invalid-feedback">
              <div *ngIf="designationAr.errors.required" class="text-danger">Enter the designation arbic</div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="form-group">
            <label for="divisionUno">Division<span class="text-danger">*</span></label>
            <!--<select class="form-control" [ngClass]="{ 'is-invalid': userMasterForm.submitted && divisionUno.invalid }" name="divisionUno"
              [(ngModel)]="model.divisionUno" #divisionUno="ngModel" required>
        <option [ngValue]="null" disabled>Choose your division</option>
        <option *ngFor="let item of division_data" [value]="item.divisionUno">
          {{item.divisionNameEn}}
        </option>
      </select>-->
            <ng-select [items]="division_data" class="form-control p-0 border-0-container" [ngClass]="{ 'is-invalid': userMasterForm.submitted && divisionUno.invalid }"
                       bindLabel="divisionNameEn"
                       bindValue="divisionUno"
                       [multiple]="false"
                       placeholder="Division"
                       name="divisionUno"
                       [(ngModel)]="model.divisionUno" #divisionUno="ngModel" required>
            </ng-select>
            <div *ngIf="userMasterForm.submitted && divisionUno.invalid" class="invalid-feedback">
              <div *ngIf="divisionUno.errors.required" class="text-danger">Select the division</div>
            </div>
          </div>
        </div>



        <div class="col-md-6 col-sm-6" *ngIf="exUser">
          <div class="form-group">
            <label for="password">Password<span class="text-danger">*</span></label>
            <input type="password" class="form-control" name="password" [(ngModel)]="model.password" #password="ngModel" [ngClass]="{ 'is-invalid': userMasterForm.submitted && password.invalid }" pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*[!@#$%^&*])(?=.*?[0-9]).{8,}$"  required />
            <div *ngIf="userMasterForm.submitted && password.invalid" class="invalid-feedback">
              <div *ngIf="password.errors.required">Password is required</div>
              <!--<div *ngIf="password.errors.minlength">Password must be at least 8 characters</div>-->
              <div *ngIf="password.errors.pattern">
                Password should have minimum 8 characters, at least 1 uppercase letter, 1 lowercase
                letter, 1 number,1 special character
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6" *ngIf="exUser">
          <div class="form-group">
            <label for="confirmPassword">Confirm Password<span class="text-danger">*</span></label>
            <input type="password" class="form-control" name="confirmPassword" [(ngModel)]="model.confirmPassword" #confirmPassword="ngModel" [ngClass]="{ 'is-invalid': userMasterForm.submitted && confirmPassword.invalid }" required />
            <div *ngIf="userMasterForm.submitted && confirmPassword.invalid" class="invalid-feedback">
              <div *ngIf="confirmPassword.errors.required">Confirm Password is required</div>
              <div *ngIf="confirmPassword.errors.mustMatch">Passwords must match</div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="form-group">
            <label for="followUp">Delegate My Access</label>
          
            <ng-select [items]="UserList" class="form-control p-0 border-0-container"
                       bindLabel="fullAttendeeName"
                       bindValue="userselUno"
                       [multiple]="false"
                       placeholder="Delegate Users"
                       name="followUp"
                       [(ngModel)]="model.followUp">
            </ng-select>
          

          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <label for="Delegate">&nbsp;</label>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="defaultCheck1" value="true" name="isDelegate" [(ngModel)]="isDelegate">
            <label class="form-check-label" for="defaultCheck1">
              Allow confidential meeting access
            </label>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="startdate">Start Date</label>
            <input type="date" class="form-control" name="startDate" [(ngModel)]="model.startDate" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="enddate">End Date</label>
            <input type="date" class="form-control" name="endDate" [(ngModel)]="model.endDate" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="followUp">Access</label>
            <ng-select [items]="accessValue" class="form-control p-0 border-0-container"
                       bindLabel="text"
                       bindValue="value"
                       placeholder="Access"
                       name="Access"
                       [(ngModel)]="model.access">
            </ng-select>

          </div>
        </div>

      </div>
      </div>
        <div class="modal-footer bg-light">
          <div class="form-group float-right">
            <button type="button" class="btn btn-secondary px-4" (click)="modalRef.hide()">Cancel</button>
            <button class="btn btn-success px-4 mx-2">Submit</button>
          </div>
        </div>
</form>
</ng-template>

<div class=" container-fluid py-3 left-menu-space" id="divMainContainer" role="main" *ngIf="isView">
  <div class="page-title-box d-flex justify-content-between bd-highlight mb-3 pb-4">
    <h4 class="mb-0 f-bold-dubai text-secondary pb-4">User view</h4>
    <div class="page-title-right pb-4"><a class="btn btn-secondary btn-sm text-white" (click)="isView=false;"><i class="fa fa-arrow-left pr-1"></i> Back</a></div>
  </div>

  <div class="row">
    <div class="col-md-6 pageloadcontainer" >
      <div class="card rounded p-3 h-100 mb-0">
        <div class="pb-2 border-bottom mb-2">
          <div class="position-absolute rounded-circle position-left-15">
            <img alt="profile" class="wh-70 rounded-circle mr-2" [src]="userInfoList.picture">
          </div>
          <div class="ml-6 px-3">
            <h6 class="f-bold-dubai mb-0">{{userInfoList.displayNameEn}}</h6>
            <Small>{{userInfoList.emailId}}</Small><br />
            <Small class="text-secondary">{{userInfoList.designationEn}}</Small><br />
            <Small class="text-secondary">{{userInfoList.divisionNameEn}}</Small>
</div>
        </div>
       
        <h6 class="f-bold-dubai">Project Lead</h6>
        <div class="d-flex text-secondary flex-row">
          <div class="p-0"><small class="f-bold-dubai project-label">PR Number</small></div>
          <div class="px-2"><small>{{userInfoList.prNumber}}</small></div>
        </div>
        <div class="d-flex text-secondary flex-row">
          <div class="p-0"><small class="f-bold-dubai project-label">Full Name</small></div>
          <div class="px-2"><small>{{userInfoList.firstname}} {{userInfoList.lastname}}</small></div>
        </div>
        <div class="d-flex text-secondary flex-row">
          <div class="p-0"><small class="f-bold-dubai project-label">Role</small></div>
          <div class="px-2"><small>{{userInfoList.role==1?'Admin User':'Basic User'}}</small></div>
        </div>
       
        <!--<div class="d-flex text-secondary flex-row">
          <div class="p-0"><small class="f-bold-dubai project-label">TBT Available</small></div>
          <div class="px-2"><small>{{userInfoList.isTBT?'Yes':'No'}}</small></div>
        </div>-->
        <div class="d-flex text-secondary flex-row">
          <div class="p-0"><small class="f-bold-dubai project-label">Last Login</small></div>
          <div class="px-2"><small>{{todayTime}}  {{todayDate}}</small></div>
        </div>
      </div>

    </div>
    <div class="col-md-6 pageloadcontainer">
      <div class="card rounded p-3 h-100">
        <h6 class="f-bold-dubai">Delegate Users</h6>
        <div class="pt-2 px-3 pb-3 border-bottom" *ngFor="let item of followUpUserList">
          <img [src]="item.picture" alt="profile" class="wh-30 rounded-circle mr-2" />
          <h6 class="card-title d-inline f-bold-dubai">{{item.displayNameEn}}</h6>
          <div class="text-success py-1">{{item.designationEn}}</div>
          <div class="p-0">
            <span class="pr-2"> {{item.prNumber}}</span> |  <span class="px-2">{{item.emailId}}</span> | <span class="px-2"><b class="text-secondary">{{item.divisionNameEn}}</b></span>| <span class="px-2">{{item.ntUsername}}</span>
          </div>
        </div>
        <div class="border rounded py-4 text-center text-muted h-100" *ngIf="followUpUserList==null ||followUpUserList.length==0 ">
          <img src="{{noDataImage}}" alt="No Data" />
          <!--<h5>No Data Found</h5>-->
        </div>
      </div>
    </div>
  </div>
</div>
